import * as React from 'react'

import { LinkButton as LinkButtonPresenter, IProps } from './presenter'

export { BUTTON_TYPE_PINK, BUTTON_TYPE_BLUE } from './presenter'

export const LinkButton = (
  props: Omit<IProps, 'pageTransitionHandler'>,
): JSX.Element => {
  const pageTransitionHandler = (href: string) => {
    window.location.href = href
  }
  return (
    <LinkButtonPresenter
      {...props}
      pageTransitionHandler={pageTransitionHandler}
    />
  )
}

export default LinkButton
